import { DatePicker } from '@atoms';
import { Form } from 'antd';
import React from 'react';
import { ControllerRenderProps, FieldValues } from 'react-hook-form';

const { Item: FormItemAntd } = Form;

type ValidationStatus =
  | ''
  | 'error'
  | 'success'
  | 'warning'
  | 'validating'
  | undefined;

export interface FormDatePickerItemProps
  extends ControllerRenderProps<FieldValues, string> {
  status: ValidationStatus;
  help?: string;
  placeholder?: string;
  onChange: (...event: any[]) => void;
  label?: string;
}
export const FormDatePickerItem: React.FC<FormDatePickerItemProps> = ({
  status,
  help,
  placeholder,
  name,
  onChange,
  label,
  ...props
}) => {
  return (
    <FormItemAntd validateStatus={status} help={help} label={label}>
      <DatePicker
        placeholder={placeholder}
        data-testid={name}
        onChange={onChange}
        {...props}
      />
    </FormItemAntd>
  );
};
